import React from "react";
import Card from "../Card";
import Card2 from "../Card/Card2";

const Articles1 = ({ articles }) => {
  const leftArticlesCount = Math.ceil(articles.length / 5);
  const leftArticles = articles.slice(0, 4);

  return (
    <div className="flex flex-col lg:flex-row  ">
      <div className="flex flex-col lg:flex-row ">
        {leftArticles.map((article, i) => {
          return <Card article={article} key={`article__${article.slug}`} />;
        })}
      </div>
    </div>
  );
};

export default Articles1;
